

import React, { useState } from "react";
import axios from "axios";
import "./student.css";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";


function StudentAdd({ onLogout }) {

    const navigate = useNavigate();
    const [course, setCourse] = useState([]);
    const [mentor, setMentor] = useState([]);
    const [clickCount, setClickCount] = useState(0);
    const [selectedMentors, setSelectedMentors] = useState([]);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phonenumber: "",
        alternatenumber: "",
        address: "",
        city: "",
        pincode: "",
        gender: "",
        yop: "",
        dob: "",
        reference: "",
        coursedetails: "",
        fees: "",
        offerfees: "",
        joiningdate: "",
        coursecompleted: "", // Yes/No
        coursecompleteddate: "",
        discontinued: "", // Yes/No
        discontinueddate: "",
        paymentmode: "", // NetCash/EMI
        emi: "",
        paymentstatus: "", // Paid/Not Paid
        certificate: "",
        interviewpreparation: "", // Start/Unstart
        interviewlevel: "",
        mentorname: "",
        paidamount: "",
        balanceamount: "",
        paymentamount: "",
        paymentdate: "",
        level1amount: "",
        level1date: "",
        level2amount: "",
        level2date: "",
        level3amount: "",
        level3date: "",
        discontinuedreason: "",
        discountamount: "",
        student_id: "",
        mentor_fees: "",
        firstpayment: "",
        finalpayment: "",
        mentor1: "",
        mentor2: "",
        mentorfees2: "",
        firstpayment2: "",
        finalpayment2: ""





    });
    const [image, setImage] = useState(null)
    // const [student_id, setStudent_id] = useState("");
    const location = useLocation();
    const studentData = location.state?.studentData || null;

    useEffect(() => {
        if (studentData) {
            setFormData((prevFormData) => ({
                ...prevFormData,
                ...studentData,
            }));
        }
    }, [studentData]);

    console.log("Updated Form Data:", formData);

    // useEffect(() => {
    //     setFormData((prev) => ({
    //         ...prev,
    //         student_id: `STU_${prev.phonenumber}`,
    //     }));
    // }, [formData.phonenumber]);

    // Example: When creating a new student only
    if (!formData.student_id && formData.phonenumber.length === 10) {
        setFormData((prev) => ({
            ...prev,
            student_id: `STU_${formData.phonenumber}`,
        }));
    }





    // let isCreating;
    // useEffect(() => {
    //     if (isCreating && !formData.student_id && formData.phonenumber.length === 10) {
    //         setFormData((prev) => ({
    //             ...prev,
    //             student_id: `STU_${formData.phonenumber}`,
    //         }));
    //     }
    // }, [formData.phonenumber, isCreating]);


    useEffect(() => {
        if (formData.paymentmode === "NetCash") {
            setFormData((prev) => ({
                ...prev,
                paymentstatus: "Paid",
            }));
        } else if (formData.paymentmode === "EMI") {
            setFormData((prev) => ({
                ...prev,
                paymentstatus: "Partially paid",
            }));
        }
    }, [formData.paymentmode]);




    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));


    };
    // const handleChange = (e) => {
    //     const { name, value } = e.target;

    //     // Auto update payment status based on selected payment mode
    //     if (name === "paymentmode") {
    //         let updatedStatus = "";
    //         if (value === "NetCash") {
    //             updatedStatus = "Paid";
    //         } else if (value === "EMI") {
    //             updatedStatus = "Partially paid";
    //         }

    //         setFormData((prev) => ({
    //             ...prev,
    //             [name]: value,
    //             paymentstatus: updatedStatus,
    //         }));
    //     } else {
    //         setFormData((prev) => ({
    //             ...prev,
    //             [name]: value,
    //         }));
    //     }
    // };




    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Submitting form data:", formData); // Debugging Log
        e.preventDefault();
        const data = new FormData();

        for (let key in formData) {
            data.append(key, formData[key]);
        }

        if (image) data.append("image", image);
        try {
            let response;
            let isUpdate = false;

            if (studentData && studentData.id) {
                // PUT request for updating existing student
                response = await axios.put(
                    // `http://localhost:8000/student.php?id=${studentData.id}`,
                    `https://crm.fazoacademy.in/php/student.php?id=${studentData.id}`,

                    formData
                );
                isUpdate = true;
            } else {
                // POST request for adding new student
                response = await axios.post(
                    // "http://localhost:8000/student.php",
                    "https://crm.fazoacademy.in/php/student.php",

                    formData
                );
            }

            console.log("API Response Data:", response.data); // Debugging Log

            if (response.data.error) {
                console.error("Server Error:", response.data.error);
                Swal.fire({
                    title: "Error!",
                    text: response.data.error,
                    icon: "error",
                    confirmButtonText: "Try Again",
                });
                return;
            }

            // Success Alert (Same message for both POST & PUT)
            Swal.fire({
                title: "Success!",
                text: isUpdate ? "Student details updated successfully!" : "Student added successfully!",
                icon: "success",
                confirmButtonText: "OK",
            });

            navigate("/student");

            // Reset form data
            setFormData({
                name: "", email: "", phonenumber: "", alternatenumber: "", address: "", city: "", pincode: "", gender: "", yop: "",
                dob: "", reference: "", coursedetails: "", fees: "", offerfees: "", joiningdate: "", coursecompleted: "",
                coursecompleteddate: "", discontinued: "", discontinueddate: "", paymentmode: "", emi: "",
                paymentstatus: "", certificate: "", interviewpreparation: "", interviewlevel: "", mentorname: "", paidamount: "",
                balanceamount: "", paymentamount: "", paymentdate: "", level1amount: "", level1date: "",
                level2amount: "", level2date: "", level3amount: "", level3date: "", discontinuedreason: "", discountamount: "",
                mentor_fees: "", firstpayment: "", finalpayment: "", mentor1: "", mentor2: ""
            });
            setImage(image)
            console.log("bhjnkl;", formData)

        } catch (error) {
            console.error("Error submitting form:", error);
            Swal.fire({
                title: "Error!",
                text: "Something went wrong while submitting the form.",
                icon: "error",
                confirmButtonText: "Try Again",
            });
        }
    };





    const fetchCourses = async () => {
        try {
            // const response = await axios.get(`http://localhost:8000/course.php`);
            const response = await axios.get(`https://crm.fazoacademy.in/php/course.php`);
            console.log("Raw API Response:", response.data);

            // Extract only the JSON part (temporary fix)
            const jsonString = response.data.substring(response.data.indexOf("["));
            const parsedData = JSON.parse(jsonString);

            setCourse(Array.isArray(parsedData) ? parsedData : []);
        } catch (error) {
            console.error("Error fetching courses:", error);
            setCourse([]);
        }
    };
    const fetchMentor = async () => {
        try {
            // const response = await axios.get(`http://localhost:8000/mentor.php`);
            const response = await axios.get(`https://crm.fazoacademy.in/php/mentor.php`);
            console.log("Raw API Response:", response.data);

            // Extract only the JSON part (temporary fix)
            const jsonString = response.data.substring(response.data.indexOf("["));
            const parsedData = JSON.parse(jsonString);

            setMentor(Array.isArray(parsedData) ? parsedData : []);
        } catch (error) {
            console.error("Error fetching courses:", error);
            setMentor([]);
        }
    };
    useEffect(() => {
        fetchCourses();
        fetchMentor();
    }, [])

    let fees = parseFloat(formData.fees) || 0;
    let discount = parseFloat(formData.discountamount) || 0;
    let totalAmount = fees - discount;

    // Assign to formData
    formData.offerfees = totalAmount;

    // Check if discount is greater than fees
    if (discount > fees) {
        alert("Discount amount cannot be greater than the fees amount!");
        formData.discountamount = "";
        return;
    }

    let initialAmount = parseFloat(formData.level1amount) || 0;

    // Check if initial amount exceeds total amount
    if (initialAmount > totalAmount) {
        alert("Initial amount cannot be greater than the total payable amount!");
        formData.level1amount = ""; // Reset initial amount input
        return;
    }

    let remainingAmount = totalAmount - initialAmount;

    // Split into 2 EMIs if total is 30,000 or more; otherwise, only 1 EMI
    let emi1 = totalAmount >= 30000 ? remainingAmount / 2 : remainingAmount;

    // Default assignments
    formData.paidamount = totalAmount;
    formData.level2amount = emi1;
    formData.level3amount = emi1;
    formData.paymentamount = totalAmount;

    // 🟡 Override EMI values if paymentmode is NetCash
    if (formData.paymentmode === "NetCash") {
        formData.level2amount = 0;
        formData.level3amount = 0;
    }

    if (formData.paymentmode === "EMI") {
        formData.paidamount = 0;
        formData.paymentamount = 0;
    }

    // const handleDaySelect = (e) => {
    //     const days = parseInt(e.target.value, 10);
    //     const currentDate = new Date(formData.level1date);
    //     currentDate.setDate(currentDate.getDate() + days);
    //     setFormData({
    //         ...formData,
    //         level2date: currentDate.toISOString().split("T")[0],
    //     });
    // };
    const handleDaySelect = (e) => {
        const days = parseInt(e.target.value, 10);

        if (!formData.level1date) {
            alert("Please select the Initial Amount Date first.");
            return;
        }

        const currentDate = new Date(formData.level1date); // Correct way to convert string to Date
        currentDate.setDate(currentDate.getDate() + days);

        const newEmiDate = currentDate.toISOString().split("T")[0];

        setFormData({
            ...formData,
            level2date: newEmiDate,
        });
    };




    const handleDaySelect1 = (e) => {
        const days = parseInt(e.target.value, 10);
        const baseDate = new Date(formData.level2date); // Start from level2date
        baseDate.setDate(baseDate.getDate() + days);
        setFormData({
            ...formData,
            level3date: baseDate.toISOString().split("T")[0],
        });
    };

    let mentorfees = parseFloat(formData.mentor_fees);
    let firstpayment1 = parseFloat(formData.firstpayment);

    if (!isNaN(mentorfees) && !isNaN(firstpayment1)) {
        if (firstpayment1 > mentorfees) {
            alert("First payment amount cannot be greater than the mentor fees amount!");
            formData.firstpayment = "";
            return;
        }
        formData.finalpayment = mentorfees - firstpayment1;
    } else {
        formData.finalpayment = "";
    }

    let mentorfees2 = parseFloat(formData.mentorfees2);
    let firstpayment3 = parseFloat(formData.firstpayment2);

    if (!isNaN(mentorfees2) && !isNaN(firstpayment3)) {
        if (firstpayment3 > mentorfees2) {  // ✅ fixed this line
            alert("First payment amount cannot be greater than the mentor fees amount!");
            formData.firstpayment2 = "";
            return;
        }
        formData.finalpayment2 = mentorfees2 - firstpayment3;
    } else {
        formData.finalpayment2 = "";
    }

    const handleAdd = () => {
        const name = formData.mentorname;
        if (name === "" || selectedMentors.includes(name)) return;

        if (clickCount === 0) {
            setFormData((prev) => ({
                ...prev,
                mentor1: name,
                // mentor: name
            }));
            setClickCount(1);
        } else if (clickCount === 1) {
            setFormData((prev) => ({
                ...prev,
                mentor2: name,
                // mentornamesecond: name
            }));
            setClickCount(2);
        } else {
            alert("Only two mentors can be added.");
            return;
        }

        setSelectedMentors([...selectedMentors, name]);
        setFormData((prev) => ({
            ...prev,
            mentorname: ""
        }));
    };


    const handleReset = () => {
        setClickCount(0);
        setSelectedMentors([]);
        setFormData((prevFormData) => ({
            ...prevFormData,
            mentorname: "",
            mentor1: "",
            mentor2: "",
        }));
    };




    return (
        <>
            <div className="container">
                <div className="navigation">
                    <a href="#">Student</a> / <a href="#" onClick={onLogout}>Logout</a>
                </div>

                <form className="student-form" onSubmit={handleSubmit}>

                    <div>
                        <label>Student Name: <span style={{ color: "red" }}>*</span></label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={(e) => {
                                const value = e.target.value;
                                const regex = /^[a-zA-Z0-9\s.]*$/; // Allows letters, numbers, spaces, and dots

                                // Prevents input from starting with a space & allows clearing input
                                if ((regex.test(value) && value.trim() !== "") || value === "") {
                                    handleChange(e);
                                }
                            }}
                            required
                        />

                    </div>

                    <div>
                        <label>Email:  <span style={{ color: "red" }}>*</span></label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={(e) => {
                                const value = e.target.value;
                                const regex = /^[a-zA-Z0-9._%+-@]*$/;
                                // Allows valid email characters during typing

                                // Allows clearing input, prevents spaces, and ensures valid characters
                                if ((regex.test(value) && !value.startsWith(" ")) || value === "") {
                                    handleChange(e);
                                }
                            }}
                            onBlur={(e) => {
                                const value = e.target.value;
                                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Full email validation

                                // Ensures a valid email only after the user finishes typing
                                if (!emailRegex.test(value) && value !== "") {
                                    alert("Invalid email format");
                                }
                            }}
                            required
                        />

                    </div>
                    <div>
                        <label>Phone Number:  <span style={{ color: "red" }}>*</span></label>
                        <input
                            type="tel"
                            name="phonenumber"
                            value={formData.phonenumber}
                            onChange={(e) => {
                                let value = e.target.value;

                                // Remove non-numeric characters
                                value = value.replace(/\D/g, "");

                                // Limit to 10 digits only
                                if (value.length <= 10) {
                                    handleChange({ target: { name: "phonenumber", value } });
                                }
                            }}
                            onBlur={(e) => {
                                if (e.target.value.length !== 10 && e.target.value !== "") {
                                    alert("Phone number must be exactly 10 digits.");
                                }
                            }}

                            required
                        />
                    </div>

                    <div>
                        <label>Alternate Number:  <span style={{ color: "red" }}>*</span></label>
                        <input type="tel"
                            name="alternatenumber"
                            value={formData.alternatenumber}
                            onChange={(e) => {
                                let value = e.target.value;

                                // Remove non-numeric characters
                                value = value.replace(/\D/g, "");

                                // Limit to 10 digits only
                                if (value.length <= 10) {
                                    handleChange({ target: { name: "alternatenumber", value } });
                                }
                            }}
                            onBlur={(e) => {
                                if (e.target.value.length !== 10 && e.target.value !== "") {
                                    alert("Phone number must be exactly 10 digits.");
                                }
                            }}
                        />
                    </div>

                    <div>
                        <label>YOP: <span style={{ color: "red" }}>*</span></label>
                        <input
                            type="number"
                            name="yop"
                            value={formData.yop}
                            onChange={(e) => {
                                let value = e.target.value;

                                // Convert value to a number
                                const year = Number(value);
                                const currentYear = new Date().getFullYear();

                                // Ensure year is between 1985 and current year
                                if (year >= 2005 && year <= currentYear) {
                                    handleChange(e);
                                }
                            }}
                            min="2005"
                            max={new Date().getFullYear()} // Dynamically set max to the current year
                            step="1"
                            placeholder="YYYY"
                            required
                        />

                    </div>

                    <div>
                        <label>DOB:  <span style={{ color: "red" }}>*</span></label>
                        <input
                            type="date"
                            name="dob"
                            value={formData.dob}
                            onChange={(e) => {
                                const value = e.target.value;
                                const minDate = "1985-01-01"; // Start from Jan 1, 1985
                                const maxDate = new Date(
                                    new Date("1985-01-01").setFullYear(1985 + 25) // Max 40 years from 1985
                                )
                                    .toISOString()
                                    .split("T")[0]; // Format as YYYY-MM-DD

                                // Restrict selection to between minDate and maxDate
                                if (value >= minDate && value <= maxDate) {
                                    handleChange(e);
                                }
                            }}
                            min="1985-01-01"
                            max={new Date(new Date("1985-01-01").setFullYear(1985 + 25))
                                .toISOString()
                                .split("T")[0]} // Dynamically calculated max date

                            required
                        />
                    </div>

                    <div>
                        <label>Address:  <span style={{ color: "red" }}>*</span></label>
                        <textarea 
                        name="address" 
                        value={formData.address} 
                        onChange={handleChange} 
                        required>

                        </textarea>
                    </div>
                    <div>
                        <label>City:  <span style={{ color: "red" }}>*</span></label>
                        <input 
                        type="text" 
                        name="city" 
                        value={formData.city}

                            onChange={(e) => {
                                const value = e.target.value;
                                const regex = /^[a-zA-Z\s]*$/; // Allows letters, numbers, spaces, and dots

                                // Prevents input from starting with a space & allows clearing input
                                if ((regex.test(value) && value.trim() !== "") || value === "") {
                                    handleChange(e);
                                }
                            }}
                            required
                        />
                    </div>
                    <div>
                        <label>Pincode:  <span style={{ color: "red" }}>*</span></label>
                        <input type="text" name="pincode" value={formData.pincode}
                            onChange={(e) => {
                                let value = e.target.value;

                                // Remove non-numeric characters
                                value = value.replace(/\D/g, "");

                                // Limit to 10 digits only
                                if (value.length <= 6) {
                                    handleChange({ target: { name: "pincode", value } });
                                }
                            }}
                            onBlur={(e) => {
                                if (e.target.value.length !== 6 && e.target.value !== "") {
                                    alert("Pincode must be exactly 6 digits.");
                                }
                            }}

                            required

                        />
                    </div>
                    <div>
                        <label>Gender:  <span style={{ color: "red" }}>*</span></label>
                        <select 
                        name="gender"
                         value={formData.gender} 
                        onChange={handleChange} 
                        required >
                            <option value="" disabled>Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                    </div>
                    <div>
                        <label>Reference:  <span style={{ color: "red" }}>*</span></label>
                        <input type="text" name="reference" value={formData.reference}
                            onChange={(e) => {
                                const value = e.target.value;
                                const regex = /^[a-zA-Z\s./ ]*$/; // Allows letters, numbers, spaces, and dots

                                // Prevents input from starting with a space & allows clearing input
                                if ((regex.test(value) && value.trim() !== "") || value === "") {
                                    handleChange(e);
                                }
                            }}
                            required
                        />
                    </div>
                    <div>
                        <label>Course Detail: <span style={{ color: "red" }}>*</span></label>
                        <select
                            name="coursedetails"
                            value={formData.coursedetails}
                            onChange={(e) => {
                                const selectedCourse = course.find(c => c.name === e.target.value);
                                setFormData({
                                    ...formData,
                                    coursedetails: e.target.value,
                                    fees: selectedCourse ? selectedCourse.amount : "" // Update fees based on selection
                                });
                            }}
                            required
                        >
                            <option value="" disabled>Select a course</option>
                            {course.map((course, index) => (
                                <option key={index} value={course.name}>
                                    {course.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label>Fees: <span style={{ color: "red" }}>*</span></label>
                        <input
                            type="text"
                            name="fees"
                            value={formData.fees}
                            readOnly // Makes the fees input field non-editable
                        />
                    </div>
                    <div>
                        <label>Discount Amount:  <span style={{ color: "red" }}>*</span></label>
                        <input type="text" name="discountamount" value={formData.discountamount}
                            onChange={(e) => {
                                const value = e.target.value;
                                const regex = /^[0-9]{0,5}$/; // Only allows numbers (0-9)

                                if (regex.test(value)) {
                                    handleChange(e);
                                }
                            }}

                        />
                    </div>

                    <div>
                        <label>Offered Price:  <span style={{ color: "red" }}>*</span></label>
                        <input type="text" name="offerfees" value={totalAmount}
                            // onChange={(e) => {
                            //     const value = e.target.value;
                            //     const regex = /^[0-9]{0,6}$/; // Only allows numbers (0-9)

                            //     if (regex.test(value)) {
                            //         handleChange(e);
                            //     }
                            // }}
                            onChange={handleChange}

                        />
                    </div>
                    <div>
                        <label>Joining Date:  <span style={{ color: "red" }}>*</span></label>
                        <input type="date" name="joiningdate" value={formData.joiningdate}
                            onChange={handleChange}
                            // min={new Date().toISOString().split("T")[0]}
                            required />
                    </div>
                    <div>
                        <label>Course Completed:  <span style={{ color: "red" }}>*</span></label>
                        <select name="coursecompleted" value={formData.coursecompleted} onChange={handleChange} required>
                            <option value="" disabled>Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    {formData.coursecompleted === "Yes" && (
                        <>
                            <div>
                                <label>Course Completion Date:  <span style={{ color: "red" }}>*</span></label>
                                <input type="date" name="coursecompleteddate"
                                    value={formData.coursecompleteddate}
                                    onChange={handleChange}
                                    // min={new Date().toISOString().split("T")[0]}
                                    required />
                            </div>
                            <div>
                                <label>Certificate:  <span style={{ color: "red" }}>*</span></label>
                                <select name="certificate" value={formData.certificate}
                                    onChange={handleChange}
                                    required>
                                    <option value="" disabled>Select</option>
                                    <option value="Received">Received</option>
                                    <option value="Not Received">Not Received</option>
                                </select>                </div>
                        </>

                    )}
                    <div>
                        <label>Discontinued:  <span style={{ color: "red" }}>*</span></label>
                        <select name="discontinued" value={formData.discontinued} onChange={handleChange} required>
                            <option value="" disabled>Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                    {formData.discontinued === "Yes" && (
                        <>
                            <div>
                                <label>Discontinued Date:  <span style={{ color: "red" }}>*</span></label>
                                <input type="date" name="discontinueddate"
                                    value={formData.discontinueddate} onChange={handleChange}
                                    // min={new Date().toISOString().split("T")[0]}
                                    required />
                            </div>
                            <div>
                                <label>Discontinued Reason:  <span style={{ color: "red" }}>*</span></label>
                                <textarea name="discontinuedreason"
                                    value={formData.discontinuedreason} onChange={handleChange}
                                    required></textarea>
                            </div>
                        </>

                    )}
                    <div>
                        <label>Payment Mode:  <span style={{ color: "red" }}>*</span></label>
                        <select name="paymentmode" value={formData.paymentmode} onChange={handleChange} required>
                            <option value="" disabled>Select</option>
                            <option value="NetCash">NetCash</option>
                            <option value="EMI">EMI</option>
                        </select>
                    </div>
                    {formData.paymentmode === "NetCash" &&
                        <>
                            <div>
                                <label>Payment Amount:  <span style={{ color: "red" }}>*</span></label>
                                <input type="number" name="paymentamount" value={totalAmount}
                                    onChange={handleChange}

                                    required
                                />
                            </div>
                            <div>
                                <label>Payment Date:  <span style={{ color: "red" }}>*</span></label>
                                <input type="date" name="paymentdate" value={formData.paymentdate}
                                    onChange={handleChange}
                                    // min={new Date().toISOString().split("T")[0]}
                                    required />
                            </div>
                            <div>
                                <label>Payment Status: <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="text"
                                    name="paymentstatus"
                                    value={formData.paymentstatus}
                                    readOnly
                                />
                            </div>

                        </>


                    }
                    {formData.paymentmode === "EMI" && (
                        <>
                            <div>
                                <label>Initial Amount: <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="number"
                                    name="level1amount"
                                    value={formData.level1amount}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^[0-9]{0,6}$/;
                                        if (regex.test(value)) {
                                            handleChange(e);
                                        }
                                    }}
                                    required
                                />
                            </div>
                            <div>
                                <label>Initial Amount Date: <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="date"
                                    name="level1date"
                                    value={formData.level1date}
                                    onChange={handleChange}
                                    // min={new Date().toISOString().split("T")[0]}
                                    required
                                />
                            </div>

                            {/* EMI Fields */}
                            <div>
                                <label>1st EMI Amount: <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="number"
                                    name="level2amount"
                                    value={emi1}
                                    readOnly
                                    required
                                />
                            </div>
                            <div>
                                <label>
                                    Select EMI Duration: <span style={{ color: "red" }}>*</span>
                                </label>
                                <select onChange={handleDaySelect} defaultValue="">
                                    <option value="" disabled>Select Days</option>
                                    {[10,11,12,13,14,15,16,17,18,19,20,21,22,23, 24, 25].map((day) => (
                                        <option key={day} value={day}>
                                            {day} Days
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label>
                                    1st EMI Date: <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="date"
                                    name="level2date"
                                    value={formData.level2date}
                                    onChange={handleChange}
                                    min={formData.level1date}
                                    required
                                />

                            </div>

                            {totalAmount >= 30000 && (
                                <>
                                    <div>
                                        <label>2nd EMI Amount: <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="number"
                                            name="level3amount"
                                            value={emi1}
                                            readOnly
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label>
                                            Select EMI Duration: <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <select onChange={handleDaySelect1} defaultValue="">
                                            <option value="" disabled>Select Days</option>
                                            {[6,7,8,9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((day) => (
                                                <option key={day} value={day}>
                                                    {day} Days
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label>2nd EMI Date: <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="date"
                                            name="level3date"
                                            value={formData.level3date}
                                            onChange={handleChange}
                                            min={formData.level2date}
                                            required
                                        />
                                    </div>
                                </>
                            )}
                            <div>
                                <label>Payment Status: <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="text"
                                    name="paymentstatus"
                                    value={formData.paymentstatus}
                                    readOnly
                                />
                            </div>


                        </>
                    )}



                    {/*  {formData.paymentstatus === "Paid" && (
                        <div>
                            <label>Paid Amount:  <span style={{ color: "red" }}>*</span></label>
                            <input type="number" name="paidamount" value={totalAmount}
                                onChange={handleChange}
                                required />
                        </div>
                    )}
                    {formData.paymentstatus === "Not Paid" && (
                        <div>
                            <label>Balance Amount:  <span style={{ color: "red" }}>*</span></label>
                            <input type="number" name="balanceamount" value={formData.balanceamount}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^[0-9]{0,6}$/; // Only allows numbers (0-9)

                                    if (regex.test(value)) {
                                        handleChange(e);
                                    }
                                }}
                                required />
                        </div>
                    )} */}
                    <div>
                        <label>Interview Preparation:  <span style={{ color: "red" }}>*</span></label>
                        <select name="interviewpreparation" value={formData.interviewpreparation} onChange={handleChange} required>
                            <option value="" disabled>Select</option>
                            <option value="Start">Start</option>
                            <option value="Not Initiated">Not Initiated</option>
                        </select>
                    </div>
                    {formData.interviewpreparation === "Start" && (
                        <div>
                            <label>Interview Level:  <span style={{ color: "red" }}>*</span></label>
                            <input type="text" name="interviewlevel"
                                value={formData.interviewlevel}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^[a-zA-Z0-9\s. ]*$/; // Allows letters, numbers, spaces, and dots

                                    // Prevents input from starting with a space & allows clearing input
                                    if ((regex.test(value) && value.trim() !== "") || value === "") {
                                        handleChange(e);
                                    }
                                }}
                                required />
                        </div>
                    )}



                    <div style={{ marginBottom: "20px" }}>
                        <label style={{ fontWeight: "bold", marginBottom: "8px", display: "block" }}>
                            Mentor Name: <span style={{ color: "red" }}>*</span>
                        </label>

                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                            maxWidth: "300px"
                        }}>
                            <select
                                name="mentorname"
                                value={formData.mentorname}
                                onChange={handleChange}
                                style={{
                                    padding: "8px",
                                    width: "100%",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc"
                                }}
                            >
                                <option value="" disabled>Select a Mentor</option>
                                {mentor
                                    .filter((mentor) => mentor.status === "Active")
                                    .map((mentor, index) => (
                                        <option
                                            key={index}
                                            // value={`${mentor.name} - ${mentor.mentor_id}`}
                                            value={mentor.name}
                                            // disabled={selectedMentors.includes(`${mentor.name} - ${mentor.mentor_id}`)}
                                            disabled={selectedMentors.includes(`${mentor.name}`)}
                                        >
                                            {/* {`${mentor.name} - ${mentor.mentor_id}`} */}
                                            {mentor.name}
                                        </option>
                                    ))}


                            </select>

                            <div style={{ display: "flex", gap: "10px" }}>
                                <button
                                    type="button"
                                    onClick={handleAdd}
                                    style={{
                                        padding: "8px 16px",
                                        backgroundColor: "#4caf50",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer"
                                    }}
                                >
                                    Add
                                </button>

                                <button
                                    type="button"
                                    onClick={handleReset}
                                    style={{
                                        padding: "8px 16px",
                                        backgroundColor: "#e57373",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer"
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Conditionally show mentor1 input */}
                    {formData.mentor1 && (
                        <>
                            <div>
                                <label>Mentor Name1: <span style={{ color: "red" }}>*</span></label>
                                <input type="text" name="mentor1" value={formData.mentor1} readOnly />
                            </div>

                            <div>
                                <label>Mentor Fees: <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="number"
                                    name="mentor_fees"
                                    value={formData.mentor_fees}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^[0-9]{0,5}$/;
                                        if (regex.test(value)) {
                                            handleChange(e);
                                        }
                                    }}
                                    required
                                />
                            </div>

                            <div>
                                <label>Mentor First Payment : <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="number"
                                    name="firstpayment"
                                    value={formData.firstpayment}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^[0-9]{0,5}$/;
                                        if (regex.test(value)) {
                                            handleChange(e);
                                        }
                                    }}
                                    required
                                />
                            </div>

                            <div>
                                <label>Mentor Final Payment: <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="number"
                                    name="finalpayment"
                                    value={formData.finalpayment}
                                    readOnly
                                    style={{ backgroundColor: "#f0f0f0" }} // Optional for clarity
                                />
                            </div>
                        </>


                    )}

                    {/* Conditionally show mentor2 input */}
                    {formData.mentor2 && (
                        <>
                            <div>
                                <label>Mentor Name2: <span style={{ color: "red" }}>*</span></label>
                                <input type="text" name="mentor2" value={formData.mentor2} readOnly />
                            </div>

                            <div>
                                <label>Mentor Fees: <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="number"
                                    name="mentorfees2"
                                    value={formData.mentorfees2}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^[0-9]{0,5}$/;
                                        if (regex.test(value)) {
                                            handleChange(e);
                                        }
                                    }}
                                    required
                                />
                            </div>

                            <div>
                                <label>Mentor First Payment : <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="number"
                                    name="firstpayment2"
                                    value={formData.firstpayment2}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^[0-9]{0,5}$/;
                                        if (regex.test(value)) {
                                            handleChange(e);
                                        }
                                    }}
                                    required
                                />
                            </div>

                            <div>
                                <label>Mentor Final Payment: <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type="number"
                                    name="finalpayment2"
                                    value={formData.finalpayment2}
                                    readOnly
                                    style={{ backgroundColor: "#f0f0f0" }}
                                />
                            </div>
                        </>
                    )}

                    {/* 
                    <div>
                        <label>Student Image:  <span style={{ color: "red" }}>*</span></label>
                        <input
                  
                             type="file"
                             accept="image/*"
                             onChange={(e) => setImage(e.target.files[0])} required
                        />

                    </div> */}

                    <button className="d-flex align-items-center " type="submit">Submit</button>
                </form>
            </div>

        </>
    );
}

export default StudentAdd;

